export default "__VITE_ASSET__KWvbH8H3__"